import { DataLayerEvents, FileDownloadEvent } from '@helpers/dataLayer';
import { getFileDownloadInfo } from '@helpers/getFileDownloadInfo';
import { isSSR } from '@helpers/ssr';

const ensureDataLayer = (): void => {
  if (isSSR) {
    return;
  }

  if (window.dataLayer === null || window.dataLayer === undefined || !Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }
};

const pushToDataLayer = (request: DataLayerEvents): void => {
  window.dataLayer.push(request);
  console.log(`Pushing new request (length: ${JSON.stringify(request).length})`, request);
};

export interface FileDownloadProps {
  linkUrl: string;
  itemName?: string;
  itemVariant?: string;
  overRides?: Partial<FileDownloadEvent>;
}
const fileDownload = ({ linkUrl, itemName, itemVariant, overRides }: FileDownloadProps): void => {
  const [fileName, fileExtension] = getFileDownloadInfo(linkUrl);

  const request: FileDownloadEvent = {
    event: 'file_download',
    link_url: linkUrl,
    file_name: fileName,
    file_extension: fileExtension,
    ...(itemName ? { item_name: itemName } : {}),
    ...(itemVariant ? { item_variant: itemVariant } : {}),
    ...overRides,
  };

  pushToDataLayer(request);
};

export const useGA4Tracking = () => {
  ensureDataLayer();

  return {
    fileDownload,
  };
};
